export const Loading = ({ label = "Loading..." }: { label?: string }) => (
  <div className="rounded-2xl border border-stone-200 bg-white px-4 py-6 text-center text-sm text-stone-500 shadow-sm">
    {label}
  </div>
);
